module.exports = __webpack_public_path__ + "img/icon_map_3_off_001.e681b550.png";